import React from 'react';
import 'semantic-ui-css/semantic.min.css'
import './App.css';
import Navbar from './components/Navbar';
import { SliderData,Sm} from './components/Data';
import Hero from './components/Hero';
import resume from './components/Resume'
import {BrowserRouter as Router } from 'react-router-dom'
import Footer from './components/Footer';
import SocialMedia from './components/SocialMedia';
import Resume from './components/Resume';
function App() {
  return (
    <>
      <Router>
      <Navbar  />
      <Hero slides={SliderData} />
        <SocialMedia sm={Sm} />
        <Resume/>
        <Footer/>
        </Router>
    </>
  );
}

export default App;
